// not all properties in Doc are going to be present. Make some optional
// export type Doc = {
//   location: string;
//   name: string;
//   language: string;
//   version: string;
//   description: string;
//   fullName: string;
//   dat: string;
//   docLink: string;
//   model: string;
// };

//Fetches all JSON objects from the source. We only use the objects with the "model" property in SelectDocsModal.tsx. Hopefully can clean up the source file later.
const apiHost = process.env.REACT_APP_API_URL;
const project = 'document';

export async function getDocs() {
    try {
        const response = await fetch(apiHost + '/api/combine?user=' + String(localStorage.getItem('user_token')) + '&project=' + project);
        const data = await response.json();

        const docs = [];

        data.forEach((doc) => {
            docs.push(doc);
        });

        return docs;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export async function getBillings() {
    try {
        const formData = new FormData();
        const user_token = localStorage.getItem('user_token');
        const user_type = localStorage.getItem('user_type');
        formData.append('user_token', user_token);
        formData.append('user_type', user_type);
        const response = await fetch(apiHost + '/billings', {
            method: 'POST',
            body: formData
        });
        return response.data;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export async function getConversations() {
    try {
        const response = await fetch(
            apiHost + '/api/conversations?user_token=' + String(localStorage.getItem('user_token')) + '&project=' + project
        );
        const data = await response.json();

        const conversations = [];

        data.forEach((conversation) => {
            conversations.push(conversation);
        });

        return conversations;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export function getLocalApiKey() {
    const key = localStorage.getItem('DocsGPTApiKey');
    return key;
}

export function getLocalRecentDocs() {
    const doc = localStorage.getItem('DocsGPTRecentDocs');
    return doc;
}

export function setLocalApiKey(key) {
    localStorage.setItem('DocsGPTApiKey', key);
}

export function setLocalRecentDocs(doc) {
    localStorage.setItem('DocsGPTRecentDocs', JSON.stringify(doc));
    let namePath = doc.name;
    if (doc.language === namePath) {
        namePath = '.project';
    }

    let docPath = 'default';
    if (doc.location === 'local') {
        docPath = 'local' + '/' + doc.name + '/';
    } else if (doc.location === 'remote') {
        docPath = doc.language + '/' + namePath + '/' + doc.version + '/' + doc.model + '/';
    }

    fetch(apiHost + '/api/docs_check', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            docs: docPath
        })
    }).then((response) => response.json());
}
